package com.veldekar.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.GenericTag
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs

/**
 * Renders an `<img>` element where `loading` (and optional `width`/`height`/`decoding`)
 * are applied to the DOM element BEFORE `src`, preventing browsers from initiating
 * an eager network request during client-side JS hydration before `loading="lazy"` is set.
 */
@Composable
fun LazyImg(
    src: String,
    alt: String = "",
    width: Int? = null,
    height: Int? = null,
    eager: Boolean = false,
    modifier: Modifier = Modifier,
) {
    GenericTag(
        name = "img",
        attrs = modifier.toAttrs {
            attr("loading", if (eager) "eager" else "lazy")
            attr("decoding", "async")
            if (eager) attr("fetchpriority", "high")
            if (width != null) attr("width", width.toString())
            if (height != null) attr("height", height.toString())
            attr("alt", alt)
            attr("src", src)
        }
    )
}
